<template lang="pug">
	label
		input(type="radio" @change="emitChange($event)" :checked="value == radioValue")
		.radiobuttonstyle
			| {{label}}
</template>

<script>
export default {
	props: {
		label:{
			default: false
		},
		value:{
			default: undefined
		},
		radioValue:{
			default: undefined
		}
	},
	data() {
		return {
			previousValue: undefined
		}
	},
	methods: {
		emitChange(event) {
			this.$emit('input', this.radioValue)
			this.$emit('change', event)
			this.previousValue = this.value
		}
	}
}
</script>
